import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

export default function IntroSection() {
  return (
    <section className="w-full px-6 md:px-15 py-16 md:py-25">
      <div className="flex flex-col md:flex-row text-black gap-10 md:gap-16">

        {/* Left text column */}
        <div className="flex flex-col md:w-2/5 items-start pb-4 md:pb-10">
          <h4 className="italic text-base md:text-lg">About us</h4>
          <h2 className="text-[26px] md:text-[32px] font-lora leading-8 md:leading-[48px] font-semibold">
            We are a Kenyan-based law firm fueled by bold strategy, sharp insight, and a commitment to stand with you — not just for you.
          </h2>
        </div>

        {/* Right text column */}
        <div className="flex flex-col flex-1 gap-6 md:gap-5 md:pl-10">
          <p className="text-[18px] md:text-[20px] font-light leading-[28px] md:leading-[32px]">
            At MMM Advocates, we’re not just your lawyers — we’re your legal partners, your advocates,
            and your shield when it matters most. We are a boutique Kenyan law firm built on clarity,
            courage, and commitment. Our strength lies in how we approach every case: with sharp legal
            insight, strategic foresight, and an unwavering resolve to secure the best possible outcome
            for you.<br /><br />
            We understand that the legal world can feel overwhelming. That’s why we position ourselves
            not just as service providers — but as your navigators through complexity, your voice in
            the courtroom, and your strategy at the negotiation table.
          </p>

          <Link
            href="/about-us"
            className="flex items-center justify-center w-[150px] md:w-[160px] px-4 py-3 gap-2 bg-secondary text-primary font-semibold"
          >
            Learn more <ArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}
